export default __webpack_public_path__ + "static/media/27.d9aa39a7.jpg";